import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { dismissAlert } from '../../store/uiSlice';
import { useGetAlertsQuery } from '../../services/alertsApi';

const prodLink = import.meta.env.VITE_PROD_LINK

export default function SiteAlert() {
  const dispatch = useDispatch();
  const dismissed = useSelector((state: RootState) => state.ui.alertDismissed);
  const { data: alerts } = useGetAlertsQuery();

  const alert = alerts?.find((a) => a.isDisplayed === 'true');

  if (!alert || dismissed) return null;

  const message = alert.message.replace('{{prodLink}}', prodLink);

  return (
    <div className={`usa-alert usa-alert--${alert.type}`} role="status" style={{ width: '100%', position: 'relative', zIndex: 2300 }}>
      <div className="usa-alert__body" style={{ paddingRight: '48px' }}>
        {alert.heading && (
          <h4
            className="usa-alert__heading"
            style={{ fontWeight: 'inherit' }}
            dangerouslySetInnerHTML={{ __html: alert.heading }}
          />
        )}
        <p
          className="usa-alert__text"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
      <button
        type="button"
        aria-label="Dismiss alert"
        onClick={() => dispatch(dismissAlert())}
        style={{ position: 'absolute', top: '8px', right: '8px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.25rem', lineHeight: 1, color: '#000' }}
      >
        ✕
      </button>
    </div>
  );
}
